export const projectsTracker = {
  actions: {
    reserveEquipment: 'Projetos: Clicou em Reservar',
    expandProject: 'Projetos: Clicou em expandir projeto',
    expandDimensioning: 'Projetos: Expandiu dimensionamentos',
    viewProposalDetails: 'Projetos: Ver detalhes',
  },
}
